export const HERO_PREMIUM_COPY = {
  caption: 'Real planner data for Moab, Utah, March 2026',
  lockedRow: 'Moon Planner: moonrise and moonset times, direction, and supermoons',
  lockedLabel: 'Premium',
  pointerDesktop: 'See what Premium includes',
  pointerMobile: 'See what Premium includes',
  coreStart: 'Core start',
  coreEnd: 'Core end',
  date: 'Date',
  moonPercent: 'Moon %',
  phase: 'Phase',
  visibility: 'Visibility',
  priceAmount: '$25',
  pricePeriod: '/year',
} as const;
